import React, { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import Icon from '../icon';
import Animate from '../animate';
import getDataOrAriaProps from '../_util/getDataOrAriaProps';
import ConfigContext from '../config-provider/ConfigContext';
export default class Alert extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            closing: true,
            closed: false,
        };
        this.handleClose = (e) => {
            e.preventDefault();
            const dom = findDOMNode(this);
            dom.style.height = `${dom.offsetHeight}px`;
            // Magic code
            // 重复一次后才能正确设置 height
            dom.style.height = `${dom.offsetHeight}px`;
            this.setState({
                closing: false,
            });
            const { onClose } = this.props;
            if (onClose) {
                onClose(e);
            }
        };
        this.animationEnd = () => {
            this.setState({
                closed: true,
                closing: true,
            });
            const { afterClose } = this.props;
            if (afterClose) {
                afterClose();
            }
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { props } = this;
        const { iconOutline, description, prefixCls: customizePrefixCls, message, closeText, banner, className = '', style, } = props;
        let { closable, showIcon, type, iconType } = props;
        const { closing, closed } = this.state;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('alert', customizePrefixCls);
        // banner模式默认有 Icon
        showIcon = banner && showIcon === undefined ? true : showIcon;
        // banner模式默认为警告
        type = banner && type === undefined ? 'warning' : type || 'info';
        if (!iconType) {
            // use outline icon in alert with description
            if (iconOutline) {
                switch (type) {
                    case 'success':
                        iconType = 'check_circle_outline-o';
                        break;
                    case 'info':
                        iconType = 'info-o';
                        break;
                    case 'error':
                        iconType = 'error_outline';
                        break;
                    case 'warning':
                        iconType = 'warning_amber-o-2';
                        break;
                    default:
                        iconType = 'default';
                }
            }
            else {
                switch (type) {
                    case 'success':
                        iconType = 'check_circle';
                        break;
                    case 'info':
                        iconType = 'info';
                        break;
                    case 'error':
                        iconType = 'error';
                        break;
                    case 'warning':
                        iconType = 'warning';
                        break;
                    default:
                        iconType = 'default';
                }
            }
        }
        const alertCls = classNames(prefixCls, {
            [`${prefixCls}-${type}`]: true,
            [`${prefixCls}-close`]: !closing,
            [`${prefixCls}-with-description`]: !!description,
            [`${prefixCls}-no-icon`]: !showIcon,
            [`${prefixCls}-banner`]: !!banner,
            [`${prefixCls}-closable`]: closable || closeText,
        }, className);
        // closeable when closeText is assigned
        if (closeText) {
            closable = true;
        }
        const closeIcon = closable ? (React.createElement("button", { type: "button", className: `${prefixCls}-close-wrapper` },
            React.createElement("a", { onClick: this.handleClose, className: `${prefixCls}-close-icon` }, closeText || React.createElement(Icon, { type: "close" })))) : null;
        const dataOrAriaProps = getDataOrAriaProps(this.props);
        return closed ? null : (React.createElement(Animate, { component: "", hiddenProp: "hidden", transitionName: `${prefixCls}-slide-up`, onEnd: this.animationEnd },
            React.createElement("div", Object.assign({ hidden: !closing, className: alertCls, style: style }, dataOrAriaProps),
                showIcon ? React.createElement(Icon, { className: `${prefixCls}-icon`, type: iconType }) : null,
                React.createElement("div", { className: `${prefixCls}-content` },
                    React.createElement("span", { className: `${prefixCls}-message` }, message),
                    React.createElement("span", { className: `${prefixCls}-description` }, description)),
                closeIcon)));
    }
}
Alert.displayName = 'Alert';
